<template>
    <v-row
      class="pa-4"
      justify="space-between"
    >
      <v-col cols="3">
        <v-list dense>
      <v-subheader>REPORTS</v-subheader>
      <v-list-item-group color="primary" v-if='!empty'>
        <v-list-item
          v-for="(item, i) in items"
          :key="i"
        >
          <v-list-item-icon>
            <v-icon >mdi-file</v-icon>
          </v-list-item-icon>
          <v-list-item-content @click='getDownloadURL(item.fileName)'>
            <v-list-item-title>{{formatFileName(item.fileName)}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
      <p class='ml-2' v-else>No report yet.Please come back and check again later.</p>
    </v-list>
      </v-col>

      <v-divider vertical></v-divider>

      <v-col
        class="d-flex text-center"
      >
       <iframe width='100%' height='800px' :src='viewFile' />
      </v-col>
    </v-row>
</template>

<script>
import { postReq} from '../helper/firestore'
export default {
  data() {
    return {
      empty : undefined,
      viewFile : undefined,
      items : null,
    }
  },
mounted(){
             postReq(process.env.VUE_APP_ROOT_API_URL +'/user/getreport',{},result=>{
                this.items = result.data
                if(result.data.length > 0) {
                  this.empty = false;
                }else{
                  this.empty = true;
                }
      })
},
methods : {
  getDownloadURL(dlURL){
 postReq(process.env.VUE_APP_ROOT_API_URL +'/patients/getFileURL',{url : dlURL},url=>{
                    this.viewFile = url.data
                })
  },
  formatFileName(name){
    let tempNames = name.split('/');
    return tempNames[tempNames.length-1]
  }
}
}
</script>

<style>

</style>